import { useEffect, useState } from "react";
import TabItem from "./TabItem";

const AccordionItem = ({
    title,
    content,
    isActive,
    onClick,
    getPostContent,
    setIsLoadingContent,
    setPostTitle,
}) => {
    const postsIds = Object.keys(content);
    const itemsLabel = Object.values(content);

    const getPost = async (id) => {
        try {
            const response = await fetch(
                `${EASYCOMMERCE.rest_base}/connectivity/docs/${id}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "X-WP-Nonce": EASYCOMMERCE.nonce,
                    },
                }
            );
            const data = await response.json();
        
            setPostTitle(data.data.doc.title);
            getPostContent(data.data.doc.description);
        } catch (err) {
            console.error("Error fetching document:", err);
        } finally {
            setIsLoadingContent(false);
        }
    };

    const [activeTab, setActiveTab] = useState(0);

    const handleTab = (index, id) => {
        setIsLoadingContent(true);
        getPost(id);
        setActiveTab(index === activeTab ? null : index);
    };

    return (
        <>
            <div
                onClick={onClick}
                className="flex cursor-pointer items-center justify-between py-6 border-b leading-8 border-[#F8F8F8]"
            >
                <p className="text-xl font-inter text-ec-body">{title}</p>
                <span className="w-8 h-8 font-inter flex items-center justify-center text-[18px] text-ec-body rounded-full bg-[#F8F8F8]">
                    {isActive ? "-" : "+"}
                </span>
            </div>
            {isActive && (
                <div>
                    {itemsLabel.map((item, index) => (
                        <>
                            <TabItem
                                key={index}
                                item={item}
                                isActive={index === activeTab}
                                onClick={() =>
                                    handleTab(index, postsIds[index])
                                }
                            />
                        </>
                    ))}
                </div>
            )}
        </>
    );
};

export default AccordionItem;
